/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./UrlToLink.vue?vue&type=template&id=0bde12f4"
import script from "./UrlToLink.vue?vue&type=script&setup=true&lang=js"
export * from "./UrlToLink.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports